import { render, staticRenderFns } from "./UnitsInputComponentNew.vue?vue&type=template&id=a9366b70"
import script from "./UnitsInputComponentNew.vue?vue&type=script&lang=js"
export * from "./UnitsInputComponentNew.vue?vue&type=script&lang=js"
import style0 from "./UnitsInputComponentNew.vue?vue&type=style&index=0&id=a9366b70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports